import { type InputFocus, inputFocus } from '../events';
import type { TrackingContextValue } from '../providers/TrackingContext';
import { GAEvent } from '../utils';

import type { InputData } from './types';

export const inputFocused = (context: TrackingContextValue, data: InputData) => {
  if (!data.fieldName) return;
  GAEvent({ action: 'Input Focused', label: data.fieldName }, context);
  inputFocus(data as InputFocus, context);
};
